import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

const blogListUrl = "/api/v2/content/Blogs";

export interface GetBlogListParameters extends ApiParameter, HasPagingParameters {
    pageId?: string;
}

export interface BlogListCollectionModel extends BaseModel {
    pagination: PaginationModel | null;
    posts: string[];
}

export function getBlogListCollection(parameter: GetBlogListParameters) {
    return get<BlogListCollectionModel>(blogListUrl, parameter);
}
